// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionBreadcrumb.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import PermissionConstants from 'logic/data/Izenda.PermissionConstants';
import actions from './Izenda.PermissionBreadcrumbActions';
import PermissionActions from './Izenda.PermissionActions';
import uiState from 'logic/Izenda.UiState.js';
import { SECTION } from 'logic/data/Izenda.PermissionConstants';
import SettingConstant from 'logic/data/Izenda.SettingConstants';
import { isNil, get, map, filter, remove } from 'lodash/fp';

@connect(actions, PermissionActions)
export default class PermissionBreadcrumb extends Component {
  componentWillMount() {
    this.props.permissionStore.model.updateSection(SECTION.SystemConfiguration);
  }

  getAllLinks() {
    const {
      permissionStore: { model: permission, tenantDetail },
      permissionStore,
      authorization
    } = this.props;
    const isSingleMode = uiState.systemMode === SettingConstant.SYSTEM_MODE;
    const currentUser = uiState.currentUser;
    let SECTION_LIST = permission.fullReportAndDashboardAccess
      ? PermissionConstants.SECTION_LIST_FULL_REPORT_DASHBOARD_ACCESS
      : PermissionConstants.SECTION_LIST;

    // remove tenant setup section when in tenant management page or in tenant setting level
    if (permissionStore.isTenantSetup || isSingleMode || tenantDetail) {
      SECTION_LIST = remove(section => section.key === PermissionConstants.SECTION.TenantSetup, SECTION_LIST);
    }

    // Remove section when user not has License
    SECTION_LIST = filter(
      section => !section.licenseKey || (section.licenseKey && authorization.checkLicense(section.licenseKey)),
      SECTION_LIST
    );

    return map(section => {
      return (
        (isNil(tenantDetail) ||
          this.props.checkShowGroupCommon(get(section.key, tenantDetail)) ||
          (section.key === 'access' && tenantDetail.access.tenantAccess !== 0) ||
          (section.key === 'scheduling' && tenantDetail.scheduling.tenantAccess !== 0) ||
          (section.key === 'dashboards' && tenantDetail.dashboards.tenantAccess !== 0) ||
          (!isNil(section.alwaysShow) && section.alwaysShow && currentUser.isSystemUser)) && (
          <a key={section.key} className='u_paddingTopBottom u_paddingRight u_floatLeft'>
            <span
              className={this.props.getActive(section.key)}
              onClick={this.props.setActive.bind(this.props, section.key)}
            >
              {section.value}
            </span>
          </a>
        )
      );
    }, SECTION_LIST);
  }

  /**
   * render component
   * @return {Object} component
   */
  render() {
    const {
      localization,
      permissionStore: {
        model: { isTenantSetup }
      }
    } = this.props;

    this.props.removeActiveClass(this.props);

    return (
      <fieldset disabled={this.props.disabledTab}>
        <GridLayout className='izenda-GridLayout-Custom'>
          <GridLayout.Row className='izenda-PermissionBreadcrumb'>
            <GridLayout.Col cols={11}>
              <span className='u_marginRight u_paddingTopBottom u_floatLeft'>
                <span className='icon-chevron-down u_borderAll' onClick={this.props.toggleAll(true)} />
                <span className='icon-chevron-up u_borderAll' onClick={this.props.toggleAll(false)} />
              </span>
              {this.getAllLinks()}
            </GridLayout.Col>
            {isTenantSetup && (
              <GridLayout.Col cols={1} className='u_textBold u_paddingTopBottom'>
                {localization.getText('PERMISSION_LABEL_TENANT_ACCESS')}
              </GridLayout.Col>
            )}
          </GridLayout.Row>
        </GridLayout>
      </fieldset>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/PermissionTab/Izenda.PermissionBreadcrumb.jsx